import { createSvgIcon } from '@mui/material';

const StopRecordIcon = createSvgIcon(
  <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M16.0013 2.66602C8.6413 2.66602 2.66797 8.63935 2.66797 15.9993C2.66797 23.3594 8.6413 29.3327 16.0013 29.3327C23.3613 29.3327 29.3346 23.3594 29.3346 15.9993C29.3346 8.63935 23.3613 2.66602 16.0013 2.66602ZM16.0013 26.666C10.1213 26.666 5.33464 21.8793 5.33464 15.9993C5.33464 10.1193 10.1213 5.33268 16.0013 5.33268C21.8813 5.33268 26.668 10.1193 26.668 15.9993C26.668 21.8793 21.8813 26.666 16.0013 26.666Z'
      fill='#1749D1'
    />
    <path d='M12.0013 11.9993H20.0013V19.9993H12.0013V11.9993Z' fill='#1749D1' />
  </svg>,
  'StopRecord',
);

export default StopRecordIcon;
